var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.567 397.6v66.267c0 18.299 14.834 33.133 33.133 33.133h397.6c18.299 0 33.132-14.834 33.132-33.133v-66.267z",
    fill: "#b5dbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.433 397.6v66.268c0 18.298-14.834 33.132-33.132 33.132h23c18.299 0 33.132-14.834 33.132-33.132v-66.268z",
    fill: "#97d0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.567 132.533v298.2c0 18.298 14.834 33.132 33.132 33.132h397.601c18.299 0 33.132-14.834 33.132-33.132v-298.2z",
    fill: "#edf5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.433 132.533v298.2c0 18.298-14.834 33.132-33.132 33.132h23c18.299 0 33.132-14.834 33.132-33.132v-298.2z",
    fill: "#d5e8fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.433 149.1v-82.834c0-18.299-14.834-33.132-33.132-33.132h-397.601c-18.299 0-33.132 14.834-33.132 33.132v82.834z",
    fill: "#ff435b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.967 73.767h-16.567c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h16.567c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#e3374e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.667 73.767h-16.567c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h16.566c4.142 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.499 7.5z",
    fill: "#e3374e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m347.9 73.767h-16.566c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h16.566c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#e3374e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m397.6 73.767h-16.567c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h16.567c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#e3374e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m115.967 66.267c0 9.149 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-49.7c-.001-9.15-7.418-16.567-16.568-16.567-9.149 0-16.567 7.417-16.567 16.567v49.7z",
    fill: "#596c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.9 66.267c0 9.149 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-49.7c0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567z",
    fill: "#596c76"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e3374e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m447.3 33.133h-23c18.299 0 33.132 14.834 33.132 33.132v82.835h23v-82.834c.001-18.299-14.833-33.133-33.132-33.133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.567 108.467h463.866v15h-463.866z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#596c76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.783 260.925c0-34.256-27.869-62.125-62.125-62.125s-62.125 27.869-62.125 62.125c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567c0-15.986 13.005-28.992 28.992-28.992 15.986 0 28.992 13.005 28.992 28.992s-13.005 28.992-28.992 28.992c-9.15 0-16.567 7.417-16.567 16.567s7.417 16.567 16.567 16.567c15.986 0 28.992 13.005 28.992 28.992 0 15.986-13.005 28.992-28.992 28.992-15.986 0-28.992-13.005-28.992-28.992 0-9.15-7.417-16.567-16.567-16.567s-16.567 7.417-16.567 16.567c0 34.256 27.869 62.125 62.125 62.125s62.125-27.869 62.125-62.125c0-17.986-7.691-34.203-19.947-45.558 12.257-11.357 19.947-27.574 19.947-45.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.379 200.061c-6.191-2.566-13.317-1.146-18.054 3.592l-33.133 33.133c-6.47 6.469-6.47 16.959 0 23.428 6.469 6.469 16.959 6.469 23.428 0l4.853-4.853v142.239c0 9.15 7.417 16.567 16.567 16.567s16.567-7.417 16.567-16.567v-182.233c-.001-6.701-4.038-12.742-10.228-15.306z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c0e4ba3c82a145275522282f8f33056e.svg";
export { ForwardRef as ReactComponent };